import axios from 'axios';
import { getAuthHeader } from './authService';
import CONFIG, { getApiUrl } from '../utils/config';

export type TournamentConfigType = 'MIN_DISTANCE' | 'ACTIVITY_CONVERSION';

export interface TournamentConfig {
  id: number;
  tournamentId: number;
  configType: TournamentConfigType;
  activityTypeId: number;
  value: string;
}

export interface CreateTournamentConfigRequest {
  tournamentId: number;
  configType: TournamentConfigType;
  activityTypeId: number;
  value: string;
}

export const getConfigsByTournament = async (tournamentId: number): Promise<TournamentConfig[]> => {
  const authHeader = getAuthHeader();
  const res = await axios.get(getApiUrl(`/api/tournament-configs/tournament/${tournamentId}`), {
    headers: { 'Authorization': authHeader }
  });
  return res.data.data;
};

export const getConfigByType = async (tournamentId: number, configType: TournamentConfigType): Promise<TournamentConfig[]> => {
  const authHeader = getAuthHeader();
  const res = await axios.get(getApiUrl(`/api/tournament-configs/tournament/${tournamentId}/type/${configType}`), {
    headers: { 'Authorization': authHeader }
  });
  return res.data.data;
};

export const createTournamentConfig = async (data: CreateTournamentConfigRequest): Promise<TournamentConfig> => {
  const authHeader = getAuthHeader();
  const res = await axios.post(getApiUrl('/api/tournament-configs'), data, {
    headers: { 'Authorization': authHeader, 'Content-Type': 'application/json' }
  });
  return res.data.data;
};

export const updateTournamentConfig = async (id: number, value: string): Promise<TournamentConfig> => {
  const authHeader = getAuthHeader();
  const res = await axios.put(getApiUrl(`/api/tournament-configs/${id}?value=${encodeURIComponent(value)}`), {}, {
    headers: { 'Authorization': authHeader, 'Content-Type': 'application/json' }
  });
  return res.data.data;
};

export const deleteTournamentConfig = async (id: number): Promise<void> => {
  const authHeader = getAuthHeader();
  await axios.delete(getApiUrl(`/api/tournament-configs/${id}`), {
    headers: { 'Authorization': authHeader }
  });
};

export const validateMinDistance = async (tournamentId: number, activityTypeId: number, distance: number): Promise<boolean> => {
  const authHeader = getAuthHeader();
  const res = await axios.get(getApiUrl(`/api/tournament-configs/validate-distance?tournamentId=${tournamentId}&activityTypeId=${activityTypeId}&distance=${distance}`), {
    headers: { 'Authorization': authHeader }
  });
  return res.data.data;
};

export const convertDistance = async (tournamentId: number, activityTypeId: number, distance: number): Promise<number> => {
  const authHeader = getAuthHeader();
  const res = await axios.get(getApiUrl(`/api/tournament-configs/convert-distance?tournamentId=${tournamentId}&activityTypeId=${activityTypeId}&distance=${distance}`), {
    headers: { 'Authorization': authHeader }
  });
  return res.data.data;
}; 